<template>
    <div class="container">
        <div class="left">
            <!-- 背景图 由于分层问题目前使用定位实现效果 -->
            <img class="bg" style="height:200px;" src="../../assets/school/bg.png" alt=""/>
            <!-- 学校 -->
            <div class="top">
                <div class="card">
                    <div class="center">
                        <div class="name">
                            <div>{{ title }}</div>
                        </div>
                        <div class="types">
                            <div>作者: {{ info.author }}</div>
                            <div>发表时间: {{ info.created_time_str }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom" style="display: flex;justify-content: center;align-content:center;flex-direction: column;">
                <img :src="info.img" style="width: 500px;margin: 0 auto;" alt=""/>
                <div class="introduction">
                    <div v-html="info.content"></div>
                </div>
            </div>
        </div>
        <div class="right">
            <HotSchool :schools="hot_school" category="推荐院校"/>
        </div>
    </div>
</template>

<script>
import Ranking from "@/components/ranking.vue";
import env from "@/utils/env";
import belong from "@/assets/schoolinfo/belong.png";
import bo from "@/assets/schoolinfo/bo.png";
import create from "@/assets/schoolinfo/create.png";
import gongxin from "@/assets/schoolinfo/gongxin.png";
import local from "@/assets/schoolinfo/local.png";
import native from "@/assets/schoolinfo/native.png";
import shuo from "@/assets/schoolinfo/shuo.png";
import type from "@/assets/schoolinfo/type.png";
import api from "@/api";
import axios from "axios";
import {ElMessage} from "element-plus";
import http from "@/utils/http";
import AMapLoader from "@amap/amap-jsapi-loader";
import SchoolPlanList from "@/components/SchoolPlanList.vue";
import GroupPlanList from "@/components/GroupPlanList.vue";
import ClassPlanList from "@/components/ClassPlanList.vue";
import HotSchool from "@/components/HotSchool.vue";

export default {
    components: {
        HotSchool,
    },
    data() {
        return {
            article_id: 0,
            title: '',
            info: {},
            hot_school: [
                {
                    'name': '浙江大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/eb6b75745f25fa1e66362052e0e08f4d62e16f87.jpg',
                    'url': '',
                    'school_id': '184',
                },
                {
                    'name': '上海交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/598c92b43ae53c11bdbfaa9f1143ab0fabe2354e.jpg',
                    'url': '',
                    'school_id': '195',
                },
                {
                    'name': '复旦大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/58978cb6515f194b491ab8305f386975b391aec2.jpg',
                    'url': '',
                    'school_id': '202',
                },
                {
                    'name': '西安交通大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/ae279abdc4f5a35b18044284fc6568f6070315ec.jpg',
                    'url': '',
                    'school_id': '389',
                },
                {
                    'name': '四川大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/fc436a9dc8d57060ee67ec49ff69e2f6873e1943.jpg',
                    'url': '',
                    'school_id': '169',
                },
                {
                    'name': '南方科技大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/f29f974a02e51eccf5ac4f1152a9f1d3198bb0b0.jpg',
                    'url': '',
                    'school_id': '2496',
                },
                {
                    'name': '北京航空航天大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/4226c1856f019c64ad0accbb6a3ca046b8d8db8f.jpg',
                    'url': '',
                    'school_id': '118',
                },
                {
                    'name': '太原理工大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/51e6abab2a2cb7c2b969d3a547e99853132bf7d8.jpg',
                    'url': '',
                    'school_id': '209',
                },
                {
                    'name': '深圳大学',
                    'logo': 'https://oss.shudaozaixian.com/images/static/logo/full/5b48e7957758956dba233e40ea2cead151537dc2.jpg',
                    'url': '',
                    'school_id': '349',
                },
            ],
        };
    },
    mounted() {
        let query = this.$route.query;

        if (query.id !== undefined) {
            this.article_id = query.id
            this.title = query.title
            document.title = this.title
            this.get_info(query.id)
        }

    },
    methods: {
        get_info(id) {
            let that = this
            let url = 'https://oss.shudaozaixian.com/cache/agent_cms_info/article/' + id + '.json?time=' + new Date().getTime()
            axios.get(url, {}).then(function (res) {
                if (res.data) {
                    that.info = res.data
                }
            }).catch(function (error) {
            });
        },
    }
};
</script>

<style lang="scss" scoped>

.container {
    display: flex;
    justify-content: space-between;

    .left {
        width: 100%;
        padding-bottom: 20px;
        background: var(--sub-bg);
        border-radius: 6px;
        position: relative;
        overflow: hidden;

        .bg {
            position: absolute;
            width: 100%;
            height: 200px;
            top: 0;
            z-index: 1;
        }

        .top {
            width: 100%;
            padding: 0 20px;
            height: 200px;
            overflow: hidden;
            position: relative;
            background: linear-gradient(93deg, #e93a29 0.32%, #ef7530 99.4%);

            .card {
                width: calc(100% - 40px);
                height: 100px;
                position: absolute;
                z-index: 2;
                border-radius: 6px;
                z-index: 99;
                padding: 20px;
                margin-top: 30px;
                display: flex;
                align-items: center;

                .logo {
                    width: 100px;
                    height: 100px;
                    margin-right: 20px;
                    border-radius: 50%;
                }

                .center {
                    width: calc(100% - 350px);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .name {
                        font-size: 32px;
                        font-weight: 500;
                        color: #ffffff;
                        display: flex;

                        .city {
                            color: #ffffff;
                            padding: 0 5px;
                            height: 21px;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            margin-top: 15px;
                            margin-left: 10px;
                            font-weight: 400;
                            line-height: 21px;
                            border-radius: 4px;
                            border: 1px solid #ffffff;
                        }
                    }

                    .types {
                        display: flex;
                        margin-bottom: 10px;
                        margin-top: 4px;

                        div {
                            padding-left: 10px;
                            border-left: 1px solid #fff;
                            color: #ffffff;
                            font-size: 16px;
                            height: 16px;
                            line-height: 16px;
                            margin-right: 10px;
                            cursor: pointer;

                            &:nth-of-type(1) {
                                padding-left: 0;
                                border: 0;
                            }
                        }
                    }

                    .labels {
                        display: flex;

                        div {
                            color: #fff;
                            font-size: 12px;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            border: 1px solid #fff;
                            padding: 0 4px;
                            margin-right: 10px;
                        }
                    }
                }

                .button {
                    width: 110px;
                    height: 36px;
                    border-radius: 6px;
                    line-height: 36px;
                    text-align: center;
                    cursor: pointer;
                    font-size: 18px;
                    margin-left: 50px;
                    color: #fff;
                    border: 1px solid #fff;
                }
            }

            .tabbar {
                width: calc(100% - 40px);
                display: flex;
                justify-content: space-between;
                position: absolute;
                bottom: 0;

                .onbar,
                .bar {
                    z-index: 2;
                    width: 33%;
                    height: 50px;
                    color: #fff;
                    border-top-right-radius: 6px;
                    border-top-left-radius: 6px;
                    line-height: 50px;
                    font-size: 20px;
                    text-align: center;
                    cursor: pointer;
                    background: #ffffff4d;
                }

                .onbar {
                    background: #fff;
                    color: var(--primary);
                }
            }
        }

        .bottom {
            margin-top: 40px;
            width: 840px;
            padding: 0 20px;

            .medal {
                width: 100%;
                height: 132px;
                display: flex;
                justify-content: space-between;

                .list {
                    width: 76px;
                    height: 110px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    font-size: var(--font-1);
                    padding: 10px;
                    font-size: 14px;
                    border-radius: 6px;
                    border: 1px solid var(--border);

                    .img {
                        width: 36px;
                        height: 36px;
                    }

                    .text {
                        margin-top: 10px;
                        text-align: center;
                        margin-bottom: 10px;
                    }

                    .gang {
                        width: 20px;
                        height: 1px;
                        background: #dedede;
                    }
                }
            }

            .introduction {
                font-size: 14px;
                color: var(--font-2);
                line-height: 28px;
                margin-top: 20px;
            }

            .map {
                width: 100%;
                height: 350px;
                padding: 30px 0;
                border-bottom: 1px solid var(--border);

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 36px;
                margin: 20px 0;

                .title_left {
                    height: 36px;
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 4px;
                    height: 22px;
                    margin-right: 10px;
                }

                .font {
                    color: var(--font-1);
                    font-size: 24px;
                    flex-wrap: 700;
                }

                .more {
                    width: 89px;
                    height: 24px;
                    font-size: 16px;
                    color: var(--primary);
                    display: flex;
                    align-items: center;

                    div:nth-of-type(2) {
                        margin-left: 5px;
                        font-size: 12px;
                    }

                    &:hover {
                        color: #ff6455;
                    }
                }

                .detail {
                    color: var(--font-3);
                    font-size: 14px;
                    margin-top: 10px;
                    margin-left: 10px;
                }
            }

            .mien {
                width: 100%;
                height: 180px;
                display: flex;
                justify-content: space-between;

                img {
                    width: 270px;
                    height: 180px;
                    border-radius: 6px;
                }
            }

            .student {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                width: 100%;

                div {
                    background: #f5f4f8;
                    width: 386px;
                    height: 50px;
                    padding-left: 20px;
                    margin-bottom: 20px;
                    font-size: 14px;
                    line-height: 50px;
                    color: var(--font-1);
                    cursor: pointer;

                    &:hover {
                        color: var(--primary);
                    }
                }
            }

            .table {
                margin: 0;
            }
        }
    }
}

.table > > > .el-table__header {
    padding: 0;
}
</style>
